import React from 'react'
import Fade from 'react-reveal/Fade'
import { CoverImg } from '../index'
import { about, top40, googleReviews } from '../../assets/imgs'
import avvoEmbed1 from './avvo-embed-1'
import avvoEmbed2 from './avvo-embed-2'
import './index.css'

const About = () =>
  <div className="tl">
    <Fade>
      <CoverImg alt={about} src={about} position="right" disclaimer disclaimerClassName="about__disclaimer" />
    </Fade>
    <Fade>
      <div className="about__content m0-auto pa3 pa4-m pa5-l">
        <div className="mb4 flex-l flex-row-l justify-start-l mb7-l">
          <h2 className="about__header serif fw4 f3 mb4 f1-ns mr7-l relative-l flex-shrink-0-l">About</h2>
          <p className="fw3 f6 f4-ns">
            Prior to founding the office, Phillip C. Hamilton, Esq. worked as a supervising attorney with The Bronx Defenders, one of the premier criminal defense practices in the nation. There, he tried several cases to acquittal and successfully defended over 1,500 clients. As a supervisor, Phillip taught the art of effective criminal defense to a team of dedicated trial attorneys, and had his work featured in The New York Times, The Huffington Post, and the New York Daily News.<br />
            <br />
            Since 2015, Phillip has primarily defended white collar professionals charged with serious, high-profile offenses. His successes include a full acquittal for a senior financial analyst charged with attempted murder, a full dismissal of charges for an executive VP charged with rape, and a number of favorably negotiated pleas for international dignitaries hailing from Luxembourg, Turkey, and South Africa. Phillip regularly appears as a legal analyst on Court TV, the Law and Crime Network, and the Fox News Channel.<br />
            <br />
            Phillip received his law degree from Yeshiva University’s Benjamin N. Cardozo School of Law where he was honored as a David Berg Fellow for the Public Interest. He is admitted to practice in New York State, the United States District Court for the Southern District of New York, and the United States District Court for the Eastern District of New York.
          </p>
        </div>
        <div className="mb4 flex-l flex-row-l justify-start-l mb7-l">
          <h2 className="about__header serif fw4 f3 mb4 f1-ns mr7-l relative-l flex-shrink-0-l">Professional Affiliations</h2>
          <div>
            <p className="fw3 f6 f4-ns">
              N.Y.S. Association of Criminal Defense Lawyers<br />
              N.Y.S. Bar Association<br />
              N.Y.C. Bar Association<br />
              The National Black Lawyers - Top 40 Under 40<br />
              The Metropolitan Black Bar Association
            </p>
            <div className='about__badges flex flex-row items-center mt6-ns mt4 relative'>
              <div dangerouslySetInnerHTML={{ __html: avvoEmbed1 }} className='h-100 mr5-l mr4-m mr3' />
              <div dangerouslySetInnerHTML={{ __html: avvoEmbed2 }} className='h-100 mr5-l mr4-m mr3' />
              <img alt="top40" src={top40} className='h-100 fit-contain mr5-l mr4-m mr3' />
              <img alt="google reviews" src={googleReviews} className ='about__google-icon' />
            </div>
          </div>
        </div>
      </div>
    </Fade>
  </div>

export default About



// WEBPACK FOOTER //
// ./src/components/about/index.js